import React, { useEffect, useReducer, useState } from "react";
/// Scroll
// import PerfectScrollbar from "react-perfect-scrollbar";
import Collapse from "react-bootstrap/Collapse";
/// Link
import { Link } from "react-router-dom";

import { MenuList } from "../../Enums/Menu";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { useDispatch, useSelector } from "react-redux";
import { Translate } from "../../Enums/Tranlate";
import { setSearch } from "../../../store/actions/AuthActions";
import { usePermissions } from "../../common/permissions";

const reducer = (previousState, updatedState) => ({
	...previousState,
	...updatedState,
});

const initialState = {
	active: "",
	activeSubmenu: "",
};

const SideBar = (props) => {
	const [active, setActive] = useState("");
	const dispatch = useDispatch();
	const [state, setState] = useReducer(reducer, initialState);
	const lang = useSelector((state) => state.auth?.lang);
	const { canView } = usePermissions();

	/**
	 * Show only what the admin may view. A parent stays visible when it has at
	 * least one visible child, even if the parent itself was not granted view —
	 * otherwise a role like "can see Admins only" would hide its own group.
	 */
	const visibleMenu = MenuList.map((item) => {
		if (item.content?.length) {
			const content = item.content.filter((child) => canView(child.permission));
			return { ...item, content };
		}
		return item;
	}).filter((item) => {
		if (item.content?.length) return true;
		// A group whose children were all filtered out disappears entirely.
		if (Array.isArray(item.content)) return canView(item.permission);
		return canView(item.permission);
	});

	//For scroll
	const [hideOnScroll, setHideOnScroll] = useState(true);
	useScrollPosition(
		({ prevPos, currPos }) => {
			const isShow = currPos.y > prevPos.y;
			if (isShow !== hideOnScroll) setHideOnScroll(isShow);
		},
		[hideOnScroll]
	);

	const handleMenuActive = (status) => {
		dispatch(setSearch(""));
		setState({ active: status });
		if (
			state.active === status &&
			MenuList.filter((res) => res?.title === status)[0]?.hasOwnProperty(
				"content"
			)
		) {
			setState({ active: "" });
		}
	};

	const handleSubmenuActive = (status) => {
		dispatch(setSearch(""));
		setState({ activeSubmenu: status });
		if (state.activeSubmenu === status) {
			setState({ activeSubmenu: "" });
		}
	};

	useEffect(() => {
		let page = window.location.pathname;
		let filter = MenuList?.filter((res) => `${res.to}` === page?.split("/")[1]);

		if (filter.length > 0) handleMenuActive(filter[0].title);
	}, [window.location.pathname]);

	/// Path
	let path = window.location.pathname;
	path = path.split("/");
	path = path[path.length - 1];
	return (
		<div className="deznav">
			<div className="deznav-scroll">
				<ul className="metismenu" id="menu">
					{visibleMenu.map((data, index) => {
						let menuClass = data.classsChange;
						return (
							<li
								className={` ${state.active === data.title ? "mm-active" : ""}`}
								key={index}>
								{data.content && data.content.length > 0 ? (
									<>
										<Link
											to={"#"}
											className="has-arrow d-flex justify-content-between position-relative"
											onClick={() => {
												handleMenuActive(data.title);
											}}>
											<div>
												{state.active === data.title
													? data.iconActive
													: data.iconDeactive}
												<span className="nav-text">
													{Translate[lang][data.text]}
												</span>
											</div>
											{state.active === data.title ? (
												<svg
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="none"
													xmlns="http://www.w3.org/2000/svg">
													<path
														d="M8 12H16"
														stroke="white"
														strokeWidth="1.5"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
														stroke="white"
														strokeWidth="1.5"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
												</svg>
											) : (
												<svg
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="none"
													xmlns="http://www.w3.org/2000/svg">
													<path
														d="M8 12H16"
														stroke="#7B7B7B"
														strokeWidth="1.5"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M12 16V8"
														stroke="#7B7B7B"
														strokeWidth="1.5"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
														stroke="#7B7B7B"
														strokeWidth="1.5"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
												</svg>
											)}
										</Link>
										<Collapse in={state.active === data.title ? true : false}>
											<ul
												className={`${
													menuClass === "mm-collapse" ? "mm-show" : ""
												}`}>
												{data.content &&
													data.content?.map((data, index) => {
														return (
															<li
																key={index}
																className={`${
																	state.activeSubmenu === data.title
																		? "mm-active"
																		: ""
																}`}>
																{data.content && data.content.length > 0 ? (
																	<>
																		<Link
																			to={data.to}
																			className={
																				data.hasMenu ? "has-arrow" : ""
																			}
																			onClick={() => {
																				handleSubmenuActive(data.title);
																			}}>
																			{Translate[lang][data.text]}
																		</Link>
																		<Collapse
																			in={
																				state.activeSubmenu === data.title
																					? true
																					: false
																			}>
																			<ul
																				className={`${
																					menuClass === "mm-collapse"
																						? "mm-show"
																						: ""
																				}`}>
																				{data.content &&
																					data.content.map((data, index) => {
																						return (
																							<li key={index}>
																								<Link
																									className={`${
																										path === data.to
																											? "mm-active"
																											: ""
																									}`}
																									onClick={() =>
																										dispatch(setSearch(""))
																									}
																									to={data.to}>
																									{Translate[lang][data.text]}
																								</Link>
																							</li>
																						);
																					})}
																			</ul>
																		</Collapse>
																	</>
																) : (
																	<Link
																		to={data.to}
																		onClick={() => {
																			dispatch(setSearch(""));
																			setActive(data.text);
																		}}
																		className={`${
																			active === data.text ? "active-link" : ""
																		}`}>
																		{Translate[lang][data.text]}
																	</Link>
																)}
															</li>
														);
													})}
											</ul>
										</Collapse>
									</>
								) : (
									<Link
										to={data.to}
										className="d-flex"
										onClick={() => handleMenuActive(data.title)}>
										{state.active === data.title
											? data.iconActive
											: data.iconDeactive}
										<span className="nav-text">
											{Translate[lang][data.text]}
										</span>
									</Link>
								)}
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
};

export default SideBar;
